import { Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Container = styled(Box)`
  position: absolute;
  top: 0px;
  left: 0px;
  aspect-ratio: 320 / 504;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`

const Rect = styled(Box)`
  background: rgba(253, 76, 0, 0.8);
  position: absolute;
  padding: 10px 20px;
  border-radius: 4px;
`

const ApostleNotQualifiedOverlay = () => {
  const { t } = useTranslation()

  return (
    <Container>
      <Rect>{t('bounty.apostle.cliam.not_qualified')}</Rect>
    </Container>
  )
}

export default ApostleNotQualifiedOverlay
